export const TYPE_OF_ENQUIRIES_LEXUS = [
  {
    label: 'New Car',
    value: 'new_car',
  },
  {
    label: 'Used Car',
    value: 'used_car',
  },
  {
    label: 'Motability',
    value: 'motability',
  },
  {
    label: 'Car Service & MOT',
    value: 'servicing',
  },
  {
    label: 'My Vehicle',
    value: 'notlisted_current',
  },
  {
    label: 'Parts & Accessories',
    value: 'parts',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'Fleet Business',
    value: 'fleet_business',
  },
  {
    label: 'Other Sales Enquiries',
    value: 'notlisted_new',
  },
]

export const TYPE_OF_ENQUIRIES_LEXUS_VALUES = {
  new_car: {
    type: 'NV',
    type_of_enquiry: 'New Car',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale',
    pvt_company_car: 'I',
  },
  used_car: {
    type: 'UV',
    type_of_enquiry: 'Used Car',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Used Vehicle Sale',
    pvt_company_car: 'I',
  },
  motability: {
    type: 'MA',
    type_of_enquiry: 'Motability enquiry',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Motability',
    pvt_company_car: 'I',
  },
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Car Service & MOT',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  notlisted_current: {
    type: 'AS',
    type_of_enquiry: 'My Vehicle',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'After Sales Enquiry',
    pvt_company_car: 'I',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'Parts & Accessories',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Repair',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
  fleet_business: {
    type: 'NF',
    type_of_enquiry: 'Fleet Business',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale - Fleet',
    pvt_company_car: 'B',
  },
  notlisted_new: {
    type: 'CU',
    type_of_enquiry: 'Other Sales Enquiries',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'General Enquiry',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_OTSO = [
  {
    label: 'Servicing and MOT',
    value: 'servicing',
  },
  {
    label: 'Servicing and MOT for my company vehicle',
    value: 'fleet_servicing',
  },

  {
    label: 'New parts or accessories',
    value: 'parts',
  },
  {
    label: 'Booking my vehicle in for a repair',
    value: 'repair',
  },
  {
    label: 'Something not listed above, related to my current vehicle',
    value: 'notlisted_current',
  },
]

export const TYPE_OF_ENQUIRIES_OTSO_VALUES = {
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Servicing and MOT',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  fleet_servicing: {
    type: 'SF',
    type_of_enquiry: 'Servicing and MOT for my company vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry - Fleet',
    pvt_company_car: 'B',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'New parts or accessories',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Booking my vehicle in for a repair',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
  notlisted_current: {
    type: 'AS',
    type_of_enquiry:
      'Something not listed above, related to my current vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'After Sales Enquiry',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_OLSO = [
  {
    label: 'Car Service & MOT',
    value: 'servicing',
  },
  {
    label: 'My Vehicle',
    value: 'notlisted_current',
  },
  {
    label: 'Parts & Accessories',
    value: 'parts',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
]

export const TYPE_OF_ENQUIRIES_OLSO_VALUES = {
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Car Service & MOT',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  notlisted_current: {
    type: 'AS',
    type_of_enquiry: 'My Vehicle',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'After Sales Enquiry',
    pvt_company_car: 'I',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'Parts & Accessories',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Repair',
    subject: 'From a visitor to your Lexus Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_TOYOTA = [
  {
    label: 'New vehicle',
    value: 'new_car',
  },
  {
    label: 'Used vehicle',
    value: 'used_car',
  },
  {
    label: 'Motability',
    value: 'motability',
  },
  {
    label: 'Business Fleet Enquiry',
    value: 'fleet_business',
  },
  {
    label: 'Servicing and MOT',
    value: 'servicing',
  },
  {
    label: 'Parts And accessories',
    value: 'parts',
  },
  {
    label: 'Repair',
    value: 'repair',
  },
  {
    label: 'Selling my Toyota',
    value: 'selling',
  },
  {
    label: 'Something else',
    value: 'notlisted_new',
  },
]

export const TYPE_OF_ENQUIRIES_TOYOTA_VALUES = {
  new_car: {
    type: 'NV',
    type_of_enquiry: 'A new Toyota',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale',
    pvt_company_car: 'I',
  },
  used_car: {
    type: 'UV',
    type_of_enquiry: 'A used vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Used Vehicle Sale',
    pvt_company_car: 'I',
  },
  motability: {
    type: 'MA',
    type_of_enquiry: 'Motability enquiry',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Motability',
    pvt_company_car: 'I',
  },
  fleet_business: {
    type: 'NF',
    type_of_enquiry: 'A new company vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'New Vehicle Sale - Fleet',
    pvt_company_car: 'B',
  },
  servicing: {
    type: 'SE',
    type_of_enquiry: 'Servicing and MOT',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Service & MOT Enquiry',
    pvt_company_car: 'I',
  },
  parts: {
    type: 'AC',
    type_of_enquiry: 'New parts or accessories',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Parts & Accessories',
    pvt_company_car: 'I',
  },
  repair: {
    type: 'RP',
    type_of_enquiry: 'Booking my vehicle in for a repair',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Repair',
    pvt_company_car: 'I',
  },
  selling: {
    type: 'ST',
    type_of_enquiry: 'Selling my current Toyota',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'Selling my current Toyota',
    pvt_company_car: 'I',
  },
  notlisted_new: {
    type: 'CU',
    type_of_enquiry: 'Something not listed above, related to a new vehicle',
    subject: 'From a visitor to your Toyota Website: via the contact us form',
    enquiry_description: 'General Enquiry',
    pvt_company_car: 'I',
  },
}

export const TYPE_OF_ENQUIRIES_GENERAL = [
  {
    label: 'Enquiry about my vehicle',
    value: 'general_enquiry:1',
  },
  {
    label: 'Enquiry about my Servicing, Parts or Accessories',
    value: 'general_enquiry:2',
  },
  {
    label: 'Help with my Toyota™',
    value: 'general_enquiry:3',
  },
  {
    label: 'Other enquiry',
    value: 'general_enquiry:4',
  },
]

export const TYPE_OF_ENQUIRIES_FINANCE = [
  {
    label: 'Arrange Collection of My Vehicle',
    value: 'Arrange Collection of My Vehicle',
  },
  {
    label: 'Settlement Request',
    value: 'Settlement Request',
  },
  {
    label: 'Invoice Enquiry',
    value: 'Invoice Enquiry',
  },
  {
    label: 'Request Copy of Your Finance Agreement',
    value: 'Request Copy of Your Finance Agreement',
  },
  {
    label: 'Difficulty Paying',
    value: 'Difficulty Paying',
  },
  {
    label: 'Address and Contact Details Change',
    value: 'Address and Contact Details Change',
  },
  {
    label: 'Bank Details Change',
    value: 'Bank Details Change',
  },
  {
    label: 'Name Change',
    value: 'Name Change',
  },
  {
    label: 'Re-finance Enquiry',
    value: 'Re-finance Enquiry',
  },
  {
    label: 'Family Bereavement',
    value: 'Family Bereavement',
  },
  {
    label: 'Complaint',
    value: 'Complaint',
  },
  {
    label: 'Payment Protection Insurance (PPI)',
    value: 'Payment Protection Insurance (PPI)',
  },
  {
    label: 'General Enquiry',
    value: 'General Enquiry',
  },
]

export const TYPE_OF_ENQUIRIES_MULTIMEDIA = [
  {
    label: 'Account',
    value: 'multimedia:1',
  },
  {
    label: 'Service & Maintenance',
    value: 'multimedia:2',
  },
  {
    label: 'Connected Services',
    value: 'multimedia:3',
  },
  {
    label: 'Connected Insurance',
    value: 'multimedia:4',
  },
  {
    label: 'Remote Services',
    value: 'multimedia:5',
  },
  {
    label: 'Standard Services',
    value: 'multimedia:6',
  },
  {
    label: 'Charging Network',
    value: 'multimedia:7',
  },
  {
    label: 'Digital Key',
    value: 'multimedia:8',
  },
  {
    label: 'Home Charge',
    value: 'multimedia:9',
  },
  {
    label: 'Multimedia',
    value: 'multimedia:10',
  },
  {
    label: 'Subscriptions',
    value: 'multimedia:11',
  },
  {
    label: 'Remote Climate',
    value: 'multimedia:12',
  },
]

export const TYPE_OF_ENQUIRIES_ROADSIDE = [
  {
    label: 'General Enquiry about Toyota Roadside Assistance (Club Toyota)',
    value: 'TRA:1',
  },
  {
    label:
      'Enquiry about renewal or cancellation of Toyota Roadside Assistance',
    value: 'TRA:2',
  },
]
